import axios from "axios";
import store from "../redux/store";
import { setIsAuthenticated } from "../redux/slices/auth";

const apiUrl = process.env.REACT_APP_API_URL;
const withCredentials = process.env.REACT_APP_API_WITH_CREDENTIALS === "true";

const axiosInstance = axios.create({
  baseURL: apiUrl,
  withCredentials: withCredentials,
});

axiosInstance.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  (response) => {
    store.dispatch(setIsAuthenticated(true)); //  Update auth state on success
    return response;
  },
  (error) => {
    console.error("Received Error", error);
    if (error.response?.status === 302 || error.code === "ERR_NETWORK") {
      store.dispatch(setIsAuthenticated(false)); //  Update auth state on error
      return Promise.reject({
        message: "User is not authenticated",
      });
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
